const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;

/**
 * Resolve shopper email from cart / hosted-page / order payloads.
 * Merchants use different field names across iframe and invoice flows.
 */
export function extractCartEmail(source) {
  if (!source || typeof source !== "object") {
    return "";
  }

  const candidates = [
    source.email,
    source.customerEmail,
    source.shopperEmail,
    source.userEmail,
    source.customerInfo?.email,
    source.customer?.email,
    source.billing?.email,
    source.billingAddress?.email,
    source.user?.email,
    source.shopper?.email,
  ];

  for (const raw of candidates) {
    const email = typeof raw === "string" ? raw.trim() : "";
    if (email && EMAIL_REGEX.test(email)) {
      return email.toLowerCase();
    }
  }

  return "";
}

/**
 * Store cart email for sign-in / sign-up prefill (Vuex auth.userEmail).
 */
export function persistCartEmail(store, source) {
  const email = extractCartEmail(source);
  if (!email) {
    return "";
  }

  store.commit("auth/setUserEmail", email);
  return email;
}
